// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__5Vfdq","label":"LabeledBox_label__2f4Nd"};